
export default function DifferentiatorSection() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <img
              src="https://public.readdy.ai/ai/img_res/fc6a406e9fc38f2f6337209872d75d17.jpg"
              alt="Consultant with client"
              className="w-full h-96 object-cover object-top rounded-lg"
            />
          </div>
          
          <div>
            <div className="text-center mb-16">
              <h2 className="text-4xl font-light text-gray-900 mb-4">
                We&apos;re Partners, Not Just Advisors
              </h2>
            </div>
            
            <p className="text-lg text-gray-600 mb-12 leading-relaxed font-light">
              We roll up our sleeves and work alongside your team—implementing solutions, 
              measuring results, and ensuring sustainable growth.
            </p>
            
            <div className="space-y-8">
              <div className="flex items-start space-x-4">
                <div className="w-1 h-1 bg-gray-400 rounded-full mt-3"></div>
                <div>
                  <h4 className="font-medium text-gray-900 mb-2">Hands-On Implementation</h4>
                  <p className="text-gray-600 font-light">We don't just provide recommendations—we help execute them.</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-1 h-1 bg-gray-400 rounded-full mt-3"></div>
                <div>
                  <h4 className="font-medium text-gray-900 mb-2">Measurable Results</h4>
                  <p className="text-gray-600 font-light">Every strategy comes with clear KPIs and regular progress reviews.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
